export default __webpack_public_path__ + "static/media/alert.af0fc796.png";